import React from 'react'
import { Widget, mk_widget, AsyncState } from 'widgets-for-react'
import { WordPress } from '../../wordpress/wordpress_api'
import { Page } from '../../cms/page/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/custom_blocks.mod'
import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { PublicSiteState } from '../../public_site.main.mod'
import { breadcrumb } from '../../../styleguide/components/components/pageHeader'
import { loader } from './loader.mod'
import { DetailItem } from './faq_overview'




export const productOverview: (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  products: AsyncState<Array<WordPress.ProductResponse>>,
  state: PublicSiteState
) => Widget<never> = (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  products: AsyncState<Array<WordPress.ProductResponse>>,
  state: PublicSiteState
) =>
    mk_widget({
      run: _ => {

        const hero = page.blocks.filter(b => b.kind == "vidda/hero" && b).pop()

        return <>

          <header className={`page-header ph ph--faq ph--secondary ph--page`}>
            <div className={`ph__outer container container--l`}>
              <div className="ph__inner">
                <div className="ph__content content">
                  <div className="ph__header">
                    <h1 className="ph__title typo--xl">{hero && hero.kind == 'vidda/hero' ? hero.attrs.title : page.extra_data.post.title.rendered}</h1>
                    <div>
                      {hero && hero.kind == 'vidda/hero' ?
                        <p className="ph__intro" dangerouslySetInnerHTML={{ __html: hero.attrs.intro }} />
                        :
                        <p className="ph__intro" dangerouslySetInnerHTML={{ __html: page.extra_data.post.title.rendered }} />} </div>
                  </div>
                </div>
              </div>
              {/* Breadcrumbs */}
              {
                state.page.custom_page_data &&
                state.page.custom_page_data.v.kind == 'r' &&
                state.page.custom_page_data.v.v.post.breadcrumb &&
                state.page.custom_page_data.v.v.post.breadcrumb.itemListElement &&
                !state.page.custom_page_data.v.v.post.is_front &&
                (
                  breadcrumb(state.page.custom_page_data.v.v.post.breadcrumb.itemListElement.map(crumb => crumb.item['@id'] ? ({ title: crumb.item.name, url: crumb.item['@id'] }) : undefined).filter(item => item != undefined))
                )

              }
            </div>
          </header>

          {
            products.kind == 'loaded' ?
              <section className="block block--product block--grid block--overview">
                <div className="block__inner container container--l grid--block">
                  <div className="block__content">
                    <ul className="block__grid grid c--columns">
                      {products.value.map(product => <DetailItem key={`product-${product.id}`} data={product} />)}
                    </ul>
                  </div>
                </div>
              </section>
              :
              loader.run(_ => { })

          }

        </>
      }
    })



// WEBPACK FOOTER //
// ./Client/components/public_site/templates/product_overview.tsx